export const holidays: any = {
    hgHolidays: [
        {
           holiday:  'New Year\'s Day',
           dayOfweek: 'Wednesday',
           day: 1,
           month: 1,
           year: 2020
        },
        {
            holiday:  'MLK Day',
            dayOfweek: 'Monday',
            day: 21,
            month: 1,
            year: 2019
         },
         {
            holiday:  'Good Friday',
            dayOfweek: 'Friday',
            day: 10,
            month: 4,
            year: 2020
         },
         {
            holiday:  'Saturday after Good Friday',
            dayOfweek: 'Saturday',
            day: 20,
            month: 4,
            year: 2019
         },
         {
            holiday:  'Memorial Day',
            dayOfweek: 'Monday',
            day: 25,
            month: 5,
            year: 2020
         },
         {
            holiday:  'Independence Day',
            dayOfweek: 'Thursday',
            day: 3,
            month: 7,
            year: 2020
         },
         {
            holiday:  'Labor Day',
            dayOfweek: 'Monday',
            day: 7,
            month: 9,
            year: 2020
         },
         {
            holiday:  'Thanksgiving Day',
            dayOfweek: 'Thursday',
            day: 26,
            month: 11,
            year: 2020
         },
         {
            holiday:  'Friday after Thanksgiving',
            dayOfweek: 'Friday',
            day: 27,
            month: 11,
            year: 2020
         },
         {
            holiday:  'Saturday after Thanksgiving',
            dayOfweek: 'Saturday',
            day: 28,
            month: 11,
            year: 2020
         },
         {
            holiday:  'Christmas Eve',
            dayOfweek: 'Thursday',
            day: 24,
            month: 12,
            year: 2020
         },
         {
            holiday:  'Christmas Day',
            dayOfweek: 'Friday',
            day: 25,
            month: 12,
            year: 2020
         },
         {
            holiday:  'New Year\'s Day',
            dayOfweek: 'Friday',
            day: 1,
            month: 1,
            year: 2021
         },
         {
            holiday:  'Good Friday',
            dayOfweek: 'Friday',
            day: 2,
            month: 4,
            year: 2021
         },
         {
            holiday:  'Memorial Day',
            dayOfweek: 'Monday',
            day: 31,
            month: 5,
            year: 2021
         },
         {
            holiday:  'Independendence Day',
            dayOfweek: 'Monday',
            day: 5,
            month: 7,
            year: 2021
         },
         {
            holiday:  'Labor Day',
            dayOfweek: 'Monday',
            day: 6,
            month: 9,
            year: 2021
         },
         {
            holiday:  'Thanksgiving Day',
            dayOfweek: 'Thursday',
            day: 25,
            month: 11,
            year: 2021
         },
         {
            holiday:  'Day after Thanksgiving Day',
            dayOfweek: 'Friday',
            day: 26,
            month: 11,
            year: 2021
         },
         {
            holiday:  'Christmas Eve',
            dayOfweek: 'Thursday',
            day: 23,
            month: 12,
            year: 2021
         },
         {
            holiday:  'Christmas Day',
            dayOfweek: 'Friday',
            day: 24,
            month: 12,
            year: 2021
         },
         {
            holiday:  'New Year\'s Day',
            dayOfweek: 'Friday',
            day: 31,
            month: 12,
            year: 2021
         },
         {
            holiday:  'Good Friday',
            dayOfweek: 'Friday',
            day: 15,
            month: 4,
            year: 2022
         },
         {
            holiday:  'Memorial Day',
            dayOfweek: 'Monday',
            day: 30,
            month: 5,
            year: 2022
         },
         {
            holiday:  'Independendence Day',
            dayOfweek: 'Monday',
            day: 4,
            month: 7,
            year: 2022
         },
         {
            holiday:  'Labor Day',
            dayOfweek: 'Monday',
            day: 5,
            month: 9,
            year: 2022
         },
         {
            holiday:  'Thanksgiving Day',
            dayOfweek: 'Thursday',
            day: 24,
            month: 11,
            year: 2022
         },
         {
            holiday:  'Day after Thanksgiving Day',
            dayOfweek: 'Friday',
            day: 25,
            month: 11,
            year: 2022
         },
         {
            holiday:  'Christmas Eve',
            dayOfweek: 'Friday',
            day: 23,
            month: 12,
            year: 2022
         },
         {
            holiday:  'Christmas Day',
            dayOfweek: 'Monday',
            day: 26,
            month: 12,
            year: 2022
         },
         {
            holiday:  'New Year\'s Day',
            dayOfweek: 'Monday',
            day: 2,
            month: 1,
            year: 2023
         },
         {
            holiday:  'New Year\'s Day',
            dayOfweek: 'Monday',
            day: 2,
            month: 1,
            year: 2023
         },
         {
            holiday:  'Good Friday',
            dayOfweek: 'Friday',
            day: 7,
            month: 4,
            year: 2023
         },
         {
            holiday:  'Memorial Day',
            dayOfweek: 'Monday',
            day: 29,
            month: 5,
            year: 2023
         },
         {
            holiday:  'Independendence Day',
            dayOfweek: 'Monday',
            day: 3,
            month: 7,
            year: 2023
         },
         {
            holiday:  'Labor Day',
            dayOfweek: 'Tuesday',
            day: 4,
            month: 9,
            year: 2023
         },
         {
            holiday:  'Thanksgiving Day',
            dayOfweek: 'Thursday',
            day: 23,
            month: 11,
            year: 2023
         },
         {
            holiday:  'Day after Thanksgiving Day',
            dayOfweek: 'Friday',
            day: 24,
            month: 11,
            year: 2023
         },
         {
            holiday:  'Christmas Eve (observed)',
            dayOfweek: 'Friday',
            day: 22,
            month: 12,
            year: 2023
         },
         {
            holiday:  'Christmas Day (observed)',
            dayOfweek: 'Monday',
            day: 25,
            month: 12,
            year: 2023
         },
         {
            holiday:  'New Year\'s Day',
            dayOfweek: 'Monday',
            day: 1,
            month: 1,
            year: 2024
         },
         {
            holiday:  'Good Friday',
            dayOfweek: 'Friday',
            day: 29,
            month: 3,
            year: 2024
         },
         {
            holiday:  'Memorial Day',
            dayOfweek: 'Monday',
            day: 27,
            month: 5,
            year: 2024
         },
         {
            holiday:  'Independendence Day',
            dayOfweek: 'Thursday',
            day: 4,
            month: 7,
            year: 2024
         },
         {
            holiday:  'Labor Day',
            dayOfweek: 'Monday',
            day: 2,
            month: 9,
            year: 2024
         },
         {
            holiday:  'Thanksgiving Day',
            dayOfweek: 'Thursday',
            day: 28,
            month: 11,
            year: 2024
         },
         {
            holiday:  'Day after Thanksgiving Day',
            dayOfweek: 'Friday',
            day: 29,
            month: 11,
            year: 2024
         },
         {
            holiday:  'Christmas Eve (observed)',
            dayOfweek: 'Tuesday',
            day: 24,
            month: 12,
            year: 2024
         },
         {
            holiday:  'Christmas Day (observed)',
            dayOfweek: 'Wednesday',
            day: 25,
            month: 12,
            year: 2024
         },
    ]
};